module.exports = "/static-assets/_next/static/images/home-99d5a7701e8028821bf0e6944957508b.png";